import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";
import {
  CreditProcessorIssueCreditNoteCreateRequestType,
  CreditProcessorIssueCreditNoteCreateResponseType,
} from "@sellar-io/api-v2/types";

export const useCreditProcessorIssueCreditNote = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: CreditProcessorIssueCreditNoteCreateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: "credit-processor/issue-credit-note",
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as CreditProcessorIssueCreditNoteCreateResponseType,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.CreditProcessor],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.OrderDocument],
      });
    },
  });
};
